import { memo } from 'react';
import { UserContactsTable } from '.';
import { TableDisplayContainer } from './containers';
import { ProspectDto } from '@zaplify/prospects';

type Props = {
    prospects: ProspectDto[];
    loading: boolean;
    onSelectRow: (userContacts: ProspectDto | ProspectDto[]) => void;
    selectedRows: Record<string, ProspectDto>;
};
export const Table = memo(({ prospects, loading, onSelectRow, selectedRows }: Props) => {
    return (
        <TableDisplayContainer className="table-display-container">
            <div className="inner-container">
                <UserContactsTable
                    prospects={prospects}
                    loading={loading}
                    selectedRows={selectedRows}
                    onSelectRow={onSelectRow}
                />
            </div>
        </TableDisplayContainer>
    );
});
